/**
 * DOM-capture suppression for Pendo (spec 094).
 *
 * Pendo's agent captures element text to match Features. In this application a
 * report cell is a WIP figure, an A/R balance, a matter name or a timekeeper's
 * compensation, and a grouped-section header is a client or matter name. None
 * of that may be captured, so every cell that renders CB data carries this
 * class.
 *
 * Deliberately dependency-free and separate from `./pendo.js`: it is imported
 * by the shared grids, and those must not pull the analytics core (or its env
 * gate) into their module graph just to name a CSS class. It is also NOT gated
 * on the API key — the class is inert when Pendo is absent, and a privacy
 * guard that only exists when instrumentation is switched on is the wrong shape.
 *
 * ⚠️ Applied to ALL `DataGrid` cells, not just report ones. DataGrid is also the
 * Matters, Contacts, Invoices, Billing, Payments and PreBills grid, and those
 * hold client names and financial data too. Suppressing capture more broadly is
 * strictly the safer direction and costs nothing.
 *
 * ⚠️ This is one of THREE things Pendo needs and only one of them is code. Also
 * required, per the tracking plan's risk register: ask Pendo Support to add
 * cb2's data attributes to the app's `htmlAttributeBlacklist`, and confirm
 * whether text capture and Session Replay are enabled for the subscription. A
 * replay of a Report Center session is a recording of a firm's financials.
 * Confirm the class name against Pendo's current agent behaviour before relying
 * on it — it is documented for agent 2.9+, which is an external contract this
 * repo cannot test.
 */

/** Suppresses Pendo DOM/text capture on an element and its subtree. */
export const PENDO_IGNORE = 'pendo-ignore'
